PatternsTemplate from ../templates/patterns
PatternTemplate from ../templates/pattern

PatternPresenter := (pattern, i: number) ->
  PatternTemplate
    class: ->
      "active" if player.activePatternIndex() is i and player.activeToolIndex() is 3

    click: ->
      player.activeToolIndex(3)
      player.activePatternIndex(i)

    preview: pattern.preview

export Patterns := (player: Player) ->
  element: PatternsTemplate
    patterns: ->
      player.patterns.map PatternPresenter

export default Patterns
